export const scheduleRoutes = {
  schedule: `/schedule`,
  internalRoutes: {},
} as const;
